import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { mediaUrl } from "../../lib/api";

function ProjectCard({ project, index }) {
  const inner = (
    <>
      <div className="relative overflow-hidden aspect-[4/3]">
        <img
          src={mediaUrl(project.image)}
          alt={project.title}
          className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-500"
        />
        <div className="absolute inset-0 bg-peca-yellow/0 group-hover:bg-peca-yellow/10 transition-colors duration-300" />
        {project.link ? (
          <span className="absolute top-4 right-4 bg-peca-yellow text-peca-black p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <ArrowUpRight size={18} />
          </span>
        ) : null}
      </div>
      <div className="pt-5">
        <span className="label-mono text-peca-yellow">{project.category}</span>
        <h3 className="mt-2 font-display font-bold uppercase text-2xl tracking-tight text-peca-cream group-hover:translate-x-1 transition-transform duration-300">
          {project.title}
        </h3>
        <p className="text-peca-grey text-sm mt-1">{project.client}</p>
      </div>
    </>
  );

  const cls = "group block";
  return (
    <motion.div
      data-testid={`project-card-${index}`}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: (index % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}
    >
      {project.link ? (
        <a href={project.link} target="_blank" rel="noopener noreferrer" className={cls}>
          {inner}
        </a>
      ) : (
        <div className={cls}>{inner}</div>
      )}
    </motion.div>
  );
}

export default function Portfolio({ content }) {
  const p = content?.portfolio;
  if (!p) return null;
  const projects = p.projects || [];

  return (
    <section id="casos" data-testid="portfolio-section" className="py-24 md:py-40 border-t border-peca-line">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
          <div>
            <span className="label-mono text-peca-yellow">✳ {p.eyebrow}</span>
            <h2 className="mt-5 font-display font-extrabold uppercase text-4xl md:text-6xl tracking-tight leading-[0.95] text-peca-cream max-w-2xl">
              {p.title}
            </h2>
          </div>
          <p className="text-peca-grey max-w-sm text-base leading-relaxed">{p.intro}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {projects.map((project, i) => (
            <ProjectCard key={i} project={project} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
